import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class ReserveRacksPostionsRequest {

    @ApiProperty()
    plantId:number;
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    saleOrderId: number;
    @ApiProperty()
    saleOrderItemId: number;
    @ApiProperty()
    issuedCases: number;
    @ApiProperty()
    stockTypeStatus:string; 
    @ApiProperty()
    varientId?:number; 
    @ApiProperty()
    packStyleId?:number; 
    @ApiProperty()
    role?:string; 
}